export const UserIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M52.6372 37.9134C50.8144 36.3117 48.6039 34.9278 46.0665 33.8003C44.9818 33.3186 43.7124
      33.807 43.2307 34.8913C42.749 35.9756 43.2374 37.2449 44.3217 37.7271C46.4613 38.6779 48.3051 39.8264
      49.8011 41.1411C51.6453 42.7616 52.7031 45.1081 52.7031 47.5801V51.5547C52.7031 52.7393 51.7393 53.7031
      50.5547 53.7031H8.44531C7.26073 53.7031 6.29688 52.7393 6.29688 51.5547V47.5801C6.29688 45.1081 7.35473
       42.7616 9.19894 41.1411C11.3696 39.2335 17.6941 34.7969 29.5 34.7969C38.2662 34.7969 45.3984 27.6646
       45.3984 18.8984C45.3984 10.1322 38.2662 3 29.5 3C20.7338 3 13.6016 10.1322 13.6016 18.8984C13.6016
       24.0232 16.0395 28.5886 19.8161 31.4978C12.9058 33.0169 8.60728 35.9408 6.36275 37.9134C3.59035 40.3492
        2 43.8723 2 47.5801V51.5547C2 55.1088 4.89116 58 8.44531 58H50.5547C54.1088 58 57 55.1088 57 51.5547V47.5801C57
        43.8723 55.4097 40.3492 52.6372 37.9134ZM17.8984 18.8984C17.8984 12.5014 23.1029 7.29688 29.5 7.29688C35.8971
        7.29688 41.1016 12.5014 41.1016 18.8984C41.1016 25.2955 35.8971 30.5 29.5 30.5C23.1029 30.5 17.8984 25.2955
        17.8984 18.8984Z"
        fill="currentColor"
      />
    </svg>
  );
};
